import script from "./MoreInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreInfo.vue?vue&type=script&setup=true&lang=js"

import "./MoreInfo.vue?vue&type=style&index=0&id=cdfc066c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdfc066c"]])

export default __exports__